import { render, staticRenderFns } from "./receivementdetail.vue?vue&type=template&id=0bf58e63&scoped=true&"
import script from "./receivementdetail.vue?vue&type=script&lang=js&"
export * from "./receivementdetail.vue?vue&type=script&lang=js&"
import style0 from "./receivementdetail.vue?vue&type=style&index=0&id=0bf58e63&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf58e63",
  null
  
)

export default component.exports